import { render, staticRenderFns } from "./expand-row.vue?vue&type=template&id=48762210&scoped=true&"
import script from "./expand-row.vue?vue&type=script&lang=js&"
export * from "./expand-row.vue?vue&type=script&lang=js&"
import style0 from "./expand-row.vue?vue&type=style&index=0&id=48762210&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48762210",
  null
  
)

export default component.exports